export default "__VITE_ASSET__09d18ff8__$_?component__"